import React from 'react';
import PropTypes from 'prop-types';

class Toast extends React.Component {
  render() {
    const { toast } = this.props;

    return (
		<section className={`toast ${toast ?  "is-active" : ""}`}>
			<i className="fas fa-plus-square toast__img" />
			<p className="toast__copy">Install this webapp on your device: tap the Menu button and then Add to Home Screen.</p>
		</section>
    );
  }
}

export default Toast;



// WEBPACK FOOTER //
// ./src/components/Toast.js